<template>
    <div class="p-10 overflow-scroll">
        <hts-data-table
            :headers="supplyHistoryDetail"
            :items="rowData" />
    </div>
</template>
<script lang="ts" setup>
const { $formatters } = useNuxtApp()
const props = defineProps({
  color: {
    type: String,
    default: 'theme'
  },
  params: Object
})
const { params } = toRefs(props)
const supplyHistoryDetailData: { [key: string]: any } = ref({})
const rowData: Array<Object> = []
onMounted(() => {
  supplyHistoryDetailData.value = params?.value?.data
})
watch(
  () => supplyHistoryDetailData.value,
  () => {
    const oldData = supplyHistoryDetailData.value.oldData
    const newData = supplyHistoryDetailData.value.newData
    const keyList: Array<String> = Object.keys(oldData)
      .concat(Object.keys(newData.$set))
      .filter((item: any) => {
        return item !== 'updatedAt' && item !== 'updatedBy'
      })
    $lodash.uniq(keyList).forEach((key: any) => {
      if (key === 'updatedAt') {
        return null
      }
      rowData.push({
        dataName: checkNameData(key),
        oldData: oldData[key],
        newData: newData.$set[key]
      })
    })
  }
)
const supplyHistoryDetail = [
  {
    field: 'dataName',
    label: 'dataName',
    headerName: $t('labels.supplyHistory.nameData'),
    sortable: true
  },
  {
    field: 'oldData',
    label: 'oldData',
    headerName: $t('labels.supplyHistory.oldData'),
    sortable: true,
    valueGetter: (params: any) => {
      const oldDataValue = params.data.oldData
      if (!oldDataValue && oldDataValue !== 0) {
        return ''
      }
      if (params.data.dataName === 'Ngày hết hạn') {
        return $formatters.date(oldDataValue)
      }
      if (params.data.dataName === 'Trạng thái') {
        switch (oldDataValue) {
        case 0:
          return $t('labels.supplyList.default')
        case 1:
          return $t('labels.supplyList.active')
        case -1:
          return $t('labels.supplyList.inactive')
        case 3:
          return $t('labels.supplyList.disable')
        default:
          break
        }
      }
      if (params.data.dataName === 'Hiển thị') {
        switch (oldDataValue) {
        case 0:
          return $t('labels.historyCategory.private')
        case 1:
          return $t('labels.historyCategory.all')
        default:
          break
        }
      }
      if (typeof oldDataValue === 'string') {
        return checkValue(oldDataValue)
      }
      if (typeof oldDataValue !== 'object') {
        return oldDataValue
      }
      return oldDataValue.$numberDecimal
    }
  },
  {
    field: 'newData',
    label: 'newData',
    headerName: $t('labels.supplyHistory.newData'),
    sortable: true,
    valueGetter: (params: any) => {
      const newDataValue = params.data.newData
      if (!newDataValue && newDataValue !== 0) {
        return ''
      }
      if (params.data.dataName === 'Ngày hết hạn') {
        return $formatters.date(newDataValue)
      }
      if (params.data.dataName === 'Trạng thái') {
        switch (newDataValue) {
        case 0:
          return $t('labels.supplyList.default')
        case 1:
          return $t('labels.supplyList.active')
        case -1:
          return $t('labels.supplyList.inactive')
        case 3:
          return $t('labels.supplyList.disable')
        default:
          break
        }
      }
      if (params.data.dataName === 'Hiển thị') {
        switch (newDataValue) {
        case 0:
          return $t('labels.historyCategory.private')
        case 1:
          return $t('labels.historyCategory.all')
        default:
          break
        }
      }
      if (typeof newDataValue === 'string') {
        return checkValue(newDataValue)
      }
      if (typeof newDataValue !== 'object') {
        return newDataValue
      }
      return newDataValue.$numberDecimal
    }
  }
]
const checkNameData = (keyData: string) => {
  if (!keyData) {
    return false
  }
  switch (keyData) {
  case 'type':
    return $t('labels.historyCategory.type')
  case 'subType':
    return $t('labels.historyCategory.subType')
  case 'name':
    return $t('labels.historyCategory.name')
  case 'vendor':
    return $t('labels.historyCategory.vendor')
  case 'price':
    return $t('labels.historyCategory.price')
  case 'weightKG':
    return $t('labels.historyCategory.weightKG')
  case 'status':
    return $t('labels.historyCategory.status')
  case 'description':
    return $t('labels.historyCategory.description')
  case 'depreciationMonth':
    return $t('labels.historyCategory.depreciationMonth')
  case 'priceLiquidation':
    return $t('labels.historyCategory.priceLiquidation')
  case 'usedTotal':
    return $t('labels.historyCategory.usedTotal')
  case 'amount':
    return $t('labels.historyCategory.amount')
  case 'expiredDate':
    return $t('labels.historyCategory.expiredDate')
  case 'privacy':
    return $t('labels.historyCategory.privacy')
  case 'fileName':
    return $t('labels.historyCategory.name')
  case 'fileExtension':
    return $t('labels.historyCategory.fileExtension')
  case 'fileSize':
    return $t('labels.historyCategory.fileSize')
  case 'path':
    return $t('labels.historyCategory.path')
  case 'url':
    return $t('labels.historyCategory.url')
  default:
    break
  }
}
const checkValue = (value: string) => {
  if (!value) {
    return false
  }
  switch (value) {
  case 'FUEL':
    return $t('labels.historyCategory.fuel')
  case 'REPAIR_LARGE':
    return $t('labels.historyCategory.repairLarge')
  case 'REPAIR_SMALL':
    return $t('labels.historyCategory.repairSmall')
  case 'ASSETS_SMALL':
    return $t('labels.historyCategory.assetsSmall')
  case 'ASSETS_LARGE':
    return $t('labels.historyCategory.assetsLarge')
  case 'MOOC':
    return $t('labels.historyCategory.mooc')
  case 'OIL':
    return $t('labels.historyCategory.oil')
  case 'WHEEL':
    return $t('labels.historyCategory.wheel')
  case 'GENERATOR':
    return $t('labels.historyCategory.generator')
  case 'CONTAINER':
    return $t('labels.historyCategory.container')
  case 'CHARGE':
    return $t('labels.historyCategory.charge')
  default:
    return value
  }
}
</script>
